module.exports = __webpack_public_path__ + "3b8854ef647489b36ac0f0983ffcec4e.svg";